import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.image_transform');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-image_transform',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.image_transform/view.scss */
/* src/app/page.image_transform/view.scss: no such file or directory */`],
})
export class PageImage_transformComponent implements OnInit {
    public imageEdit: any = this.defaultImageEdit();
    public imageItems: any[] = [];
    public resultDataUrl: string = '';
    public resultFilename: string = '';
    public loading: boolean = false;
    public error: string = '';
    public elapsed: number = 0;
    public modelUsed: string = '';
    private nextImageId: number = 1;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public defaultImageEdit() {
        return {
            prompt: '',
            model: 'gpt-image-1',
            quality: 'medium',
            size: 'auto',
            outputFormat: 'png',
            background: 'auto'
        };
    }

    public get hasImages() {
        return this.imageItems.length > 0;
    }

    public get targetImageName() {
        return this.imageItems.length ? this.imageItems[0].name : '';
    }

    public async onFileChange(event: any) {
        const input = event && event.target ? event.target : null;
        const files: File[] = input && input.files ? (Array.from(input.files as FileList) as File[]) : [];
        if (!files.length) return;

        if (this.imageItems.length + files.length > 16) {
            this.error = '이미지는 최대 16개까지 업로드할 수 있습니다.';
            await this.service.render();
            if (input) input.value = '';
            return;
        }

        const items: any[] = [];
        for (const file of files) {
            if (!/^image\/(png|jpeg|jpg|webp)$/i.test(file.type || '')) {
                this.error = 'PNG, JPG, WEBP 이미지만 업로드할 수 있습니다.';
                await this.service.render();
                if (input) input.value = '';
                return;
            }
            if (file.size > 50 * 1024 * 1024) {
                this.error = '이미지 파일은 각각 50MB 이하만 사용할 수 있습니다.';
                await this.service.render();
                if (input) input.value = '';
                return;
            }
            items.push({
                id: `img-${this.nextImageId++}`,
                name: file.name || `image-${this.nextImageId}`,
                type: file.type || 'image/png',
                size: file.size,
                dataUrl: await this.readFileAsDataUrl(file)
            });
        }

        this.imageItems = [...this.imageItems, ...items];
        this.resultDataUrl = '';
        this.resultFilename = '';
        this.error = '';
        this.elapsed = 0;
        this.modelUsed = '';
        if (input) input.value = '';
        await this.service.render();
    }

    public makeFirst(index: number) {
        if (index <= 0 || index >= this.imageItems.length) return;
        const copy = [...this.imageItems];
        const [item] = copy.splice(index, 1);
        copy.unshift(item);
        this.imageItems = copy;
        this.clearResult();
    }

    public moveImage(index: number, delta: number) {
        const next = index + delta;
        if (index < 0 || next < 0 || index >= this.imageItems.length || next >= this.imageItems.length) return;
        const copy = [...this.imageItems];
        [copy[index], copy[next]] = [copy[next], copy[index]];
        this.imageItems = copy;
        this.clearResult();
    }

    public deleteImage(index: number) {
        if (index < 0 || index >= this.imageItems.length) return;
        this.imageItems = this.imageItems.filter((_: any, i: number) => i !== index);
        this.clearResult();
    }

    public async runImageEdit() {
        if (!this.imageItems.length) {
            alert('먼저 이미지를 업로드해 주세요.');
            return;
        }

        const prompt = String(this.imageEdit.prompt || '').trim();
        if (!prompt) {
            alert('변경할 내용을 입력해 주세요.');
            return;
        }

        this.loading = true;
        this.error = '';
        this.resultDataUrl = '';
        this.resultFilename = '';
        this.elapsed = 0;
        this.modelUsed = '';
        await this.service.render();

        const numberedImages = this.imageItems.map((item: any, index: number) => ({
            label: `${index + 1}번`,
            role: index === 0 ? 'target' : 'reference',
            filename: item.name,
            dataUrl: item.dataUrl
        }));
        const promptWithImageOrder = [
            '업로드된 이미지는 입력 순서대로 1번, 2번, 3번입니다.',
            '1번 이미지를 수정 대상으로 사용하고, 2번 이후 이미지는 참고 이미지로 사용하세요.',
            '사용자가 번호를 언급하면 이 이미지 번호 기준으로 해석하세요.',
            '',
            prompt
        ].join('\n');
        const payload = {
            ...this.imageEdit,
            prompt: promptWithImageOrder,
            userPrompt: prompt,
            images: numberedImages,
            sourceFilename: this.imageItems[0].name
        };

        try {
            const response = await wiz.call('edit_image', { payload: JSON.stringify(payload) });
            const data = response.data || {};
            if (response.code !== 200) {
                throw new Error(data.message || '이미지 변형에 실패했습니다.');
            }

            this.resultDataUrl = data.imageDataUrl || '';
            this.resultFilename = data.filename || 'edited_image.png';
            this.elapsed = Number(data.elapsed || 0);
            this.modelUsed = data.model || this.imageEdit.model || '';
            if (!this.resultDataUrl) {
                throw new Error('변형 결과 이미지가 비어 있습니다.');
            }
        } catch (error: any) {
            this.error = error && error.message ? error.message : '이미지 변형 중 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async reset() {
        this.imageEdit = this.defaultImageEdit();
        this.imageItems = [];
        this.resultDataUrl = '';
        this.resultFilename = '';
        this.loading = false;
        this.error = '';
        this.elapsed = 0;
        this.modelUsed = '';
        this.nextImageId = 1;
        await this.service.render();
    }

    public downloadResult() {
        if (!this.resultDataUrl) return;
        this.downloadDataUrl(this.resultDataUrl, this.resultFilename || 'edited_image.png');
    }

    private clearResult() {
        this.resultDataUrl = '';
        this.resultFilename = '';
        this.elapsed = 0;
        this.modelUsed = '';
        this.error = '';
    }

    private readFileAsDataUrl(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error || new Error('이미지를 읽지 못했습니다.'));
            reader.readAsDataURL(file);
        });
    }

    private downloadDataUrl(dataUrl: string, filename: string) {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}

export default PageImage_transformComponent;